import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../services/api";
import "./HotelDashboard.css";

export default function HotelDashboard() {
  const navigate = useNavigate();
  const [hotel, setHotel] = useState(null);

  useEffect(() => {
    const hotelId = localStorage.getItem("hotelId");

    if (!hotelId) {
      alert("Please login again");
      navigate("/hotel/login");
      return;
    }

    API.get(`/hotel/${hotelId}`)
      .then((res) => {
        setHotel(res.data);
      })
      .catch(() => {
        alert("Unable to fetch hotel details");
      });
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  if (!hotel) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (
    <>
      {/* HEADER */}
      <header className="dashboard-header">
        <div className="header-container">
          <h1 className="logo">SaveBite</h1>

          <nav className="nav">
            <Link to="/hotel/dashboard">Dashboard</Link>
            <Link to="/hotel/add-surplus">Add Surplus</Link>
            <Link to="/hotel/donationevent">Donation</Link>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </nav>
        </div>
      </header>

      {/* MAIN CONTENT */}
      <div className="dashboard-container">
        <h2>Welcome, {hotel.hotelName} 👋</h2>

        {/* PROFILE CARD */}
        <div className="profile-card">
          <h3>My Account</h3>
          <p><strong>Email:</strong> {hotel.email}</p>
          <p><strong>Address:</strong> {hotel.address}</p>
          <p><strong>Phone:</strong> {hotel.phone}</p>
        </div>

        {/* ACTION CARDS */}
        <div className="action-cards">
          <div className="card">
            <h4>Add Surplus Food</h4>
            <p>Donate leftover food to NGOs</p>
            <Link to="/hotel/add-surplus" className="card-btn">
              Add Now
            </Link>
          </div>

          <div className="card">
            <h4>View Surplus History</h4>
            <p>Check food donations status</p>
            <button className="card-btn secondary">
              Coming Soon
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
